import VisaProgress from "./VisaProgress";
import VisaMaterialList from "./VisaMaterialList";
import VisaAuditMaterialInfo from "./VisaUploadFiles";

const ACTION = {
  ...VisaProgress.ACTION,
  ...VisaMaterialList.ACTION,
  ...VisaAuditMaterialInfo.ACTION,
};

const ACTION_TYPES = {
  ...VisaProgress.ACTION_TYPES,
  ...VisaMaterialList.ACTION_TYPES,
  ...VisaAuditMaterialInfo.ACTION_TYPES,
};

const Visa = {
  ACTION,
  ACTION_TYPES
}

export default Visa;